import {
	Button,
	FormErrorAlert,
	Label,
	LoadingDots,
	RenderIf,
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@somewear/ui";
import * as React from "react";

interface OrgSelectFormProps {
	organizations: { id: string; name: string }[];
	selectedOrgId: string;
	onSelectedOrgChange: (orgId: string) => void;
	isCreatingKey?: boolean;
	orgError?: string;
	onSubmit: (e: React.FormEvent) => void;
	onCancel?: () => void;
}

export function OrgSelectForm({
	organizations,
	selectedOrgId,
	onSelectedOrgChange,
	isCreatingKey = false,
	orgError = "",
	onSubmit,
	onCancel,
}: OrgSelectFormProps) {
	return (
		<form onSubmit={onSubmit}>
			<div className="mb-4">
				<Label className="block text-sm font-medium mb-2">Organization</Label>
				<Select
					value={selectedOrgId}
					onValueChange={onSelectedOrgChange}
					disabled={isCreatingKey}
				>
					<SelectTrigger className="w-full dark:bg-stealth-gradient-blue dark:text-white dark:hover:bg-stealth-gradient-blue">
						<SelectValue placeholder="Select an organization" />
					</SelectTrigger>

					<SelectContent className="bg-stealth-button border-stealth-border dark">
						{organizations.map((org) => (
							<SelectItem key={org.id} value={org.id}>
								{org.name}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</div>

			<RenderIf condition={!!orgError}>
				<FormErrorAlert showSeverity={false} title="Error" description={orgError} />
			</RenderIf>

			<div className={`mt-8 grid gap-4 ${onCancel ? "grid-cols-2" : "grid-cols-1"}`}>
				{onCancel && (
					<Button
						className="dark:border-input backdrop-blur-sm"
						type="button"
						variant="outline"
						size="lg"
						onClick={onCancel}
						disabled={isCreatingKey}
					>
						Cancel
					</Button>
				)}
				<Button type="submit" size="lg" disabled={isCreatingKey || !selectedOrgId}>
					{isCreatingKey ? <LoadingDots /> : "Continue"}
				</Button>
			</div>
		</form>
	);
}
